import { CartInfo } from "src/types/cartInfo";
import { Cart, LineItem } from "src/types/ctgraphql.d";

export const getCartItemsCount = (lineItems?: LineItem[]): number =>
  lineItems?.reduce(
    (sum, item) => sum + ((item?.quantity as number) || 0),
    0
  ) || 0;

export const getCartInfo = (cart?: Cart | null): CartInfo => ({
  id: cart?.id || "",
  version: (cart?.version as number) || 0,
});
